import ImageFullWidth from './component.jsx'
export default ImageFullWidth
